import { render, staticRenderFns } from "./RadStakingRecords.vue?vue&type=template&id=a472d020&scoped=true"
import script from "./RadStakingRecords.vue?vue&type=script&lang=js"
export * from "./RadStakingRecords.vue?vue&type=script&lang=js"
import style0 from "./RadStakingRecords.vue?vue&type=style&index=0&id=a472d020&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a472d020",
  null
  
)

export default component.exports